// Tokens de push nativo (app Android, ver useNativePushRegistration) de um
// usuário — aba DISPOSITIVOS CONECTADOS em Editar Usuário (pedido
// 2026-09-11: "tem que ter o token gerado... quando o usuário acessou o
// app"). Canal separado das sessões web (gpsdrive-user-sessions.service.ts)
// — um usuário pode ter uma sessão web ativa e nenhum token FCM (nunca
// abriu o app nativo), ou vice-versa.
import { gpsDriveDelete, gpsDriveGet } from "@/lib/api/gpsdrive-client";

export interface UserFcmToken {
  id: string;
  token: string;
  createdAt: string;
  lastSeenAt: string;
}

export const gpsDriveUserFcmTokensService = {
  list: (userId: string) => gpsDriveGet<UserFcmToken[]>(`/api/v1/users/${userId}/fcm-tokens`),
  revoke: (userId: string, tokenId: string) =>
    gpsDriveDelete<void>(`/api/v1/users/${userId}/fcm-tokens/${tokenId}`),
};
